import Axios from "axios";
// import store from '@/store/index'
import Vue from 'vue'
import { getParams } from "./getParams"



// 创建axios实例
const request = Axios.create({
    baseURL: process.env.BASE_URL, //URL地址   环境变量文件 .env.development
    timeout: 60000,//超时
    withCredentials: false,  //跨域时若要发生cookie,需要设置该选项
})

// 请求拦截器
request.interceptors.request.use(
    async config => {
        var params = await getParams()

        config.headers = {
            ...config.headers,
            ...params
        }

        return config
    },
    error => {
        return Promise.reject(error)
    }
);

// 响应拦截器
request.interceptors.response.use(
    response => {
        const res = response.data;
        if (res.code != 200) {
            Vue.prototype.$Message.message(res.message || res.msg || "Error");
            return Promise.reject(new Error(res.message || res.msg || 'Error'));
        } else {
            return res;
        }
    },
    error => {
        console.log('request-error', error)
        if(error.config.url == "/app/im_link/save_graffiti_result") return;
        if (error.message.includes("Network Error")) {
            Vue.prototype.$Message.message("网络异常，请检查您的网络");
        } else if (error.message.includes('timeout')) {
            Vue.prototype.$Message.message("请求超时，请重试");
        } else {
            Vue.prototype.$Message.message(error.message);
        }
        // 返回接口返回的错误信息
        return Promise.reject(error);
    }
);

export default request;

